import { showPopup } from '../popup/popup';
import './captchaPopup.css';

// Mini replica of the reCAPTCHA checkbox, so users know exactly what to look for.
const checkboxHint = `
    <div class="captcha-popup-hint" aria-hidden="true">
        <span class="captcha-popup-hint-box"></span>
        <span>I’m not a robot</span>
    </div>`;

const scrollToCaptcha = () => {
    const captcha = document.querySelector('.captcha-wrapper');
    if (captcha) {
        captcha.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
};

// Shown when a form is submitted before the reCAPTCHA checkbox is ticked.
export const showCaptchaRequiredPopup = () =>
    showPopup({
        variant: 'warning',
        icon: 'shield',
        title: 'One quick check',
        html: `<p>Please tick the box below so we know it’s really you.</p>${checkboxHint}`,
        confirmText: 'Take me there',
    }).then((result) => {
        scrollToCaptcha();
        return result;
    });

// Shown when the reCAPTCHA widget fails to load (network issue, blocked script, bad site key).
export const showCaptchaErrorPopup = (onRetry?: () => void) =>
    showPopup({
        variant: 'error',
        icon: 'refresh',
        title: 'Verification didn’t load',
        text: 'We couldn’t reach the verification service. Check your connection and try again.',
        confirmText: 'Try again',
        cancelText: 'Close',
    }).then((result) => {
        if (result.isConfirmed && onRetry) {
            onRetry();
        }
        return result;
    });
